import { WithdrawOrderStatus } from '../../enums/WithdrawOrderStatus';
import { WithdrawOrderDetail as WithdrawOrderDetailI } from '../types/WithdrawOrder';

export class WithdrawOrderDetail implements WithdrawOrderDetailI {
    id = -1;

    mchName?: string | undefined;

    accountName?: string | undefined;

    bankName?: string | undefined;

    accountNo?: string | undefined;

    payAmt = 0;

    receivedAmt = 0;

    platAmt = 0;

    orderNum?: string | undefined;

    purpose?: string | undefined;

    source?: string | undefined;

    status: WithdrawOrderStatus = WithdrawOrderStatus.Default;

    updateTime?: string | undefined;

    createTime?: string | undefined;

    channel?: string | undefined;
}
